var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswersOther2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1594_16093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4995 25.5C18.3404 25.5 18.1842 25.4351 18.0672 25.3129L14.5792 21.6668H0.611123C0.273627 21.6668 0 21.3808 0 21.0278V3.13882C0 2.78603 0.273627 2.5 0.611123 2.5H23.3887C23.7262 2.5 23.9999 2.78603 23.9999 3.13882V21.0277C23.9999 21.3805 23.7262 21.6666 23.3887 21.6666H19.1105V24.861C19.1105 25.1194 18.9616 25.3524 18.7332 25.4512C18.6576 25.484 18.5781 25.4999 18.4995 25.4999V25.5ZM1.22238 20.3889H14.8322C14.9944 20.3889 15.1498 20.4562 15.2644 20.5759L17.8881 23.3186V21.0277C17.8881 20.6749 18.1617 20.3887 18.4992 20.3887H22.7775V3.77779H1.22238V20.3889Z",
    fill: "#062F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8019 7.61114H4.19706C3.85956 7.61114 3.58594 7.32511 3.58594 6.97232C3.58594 6.61953 3.85956 6.3335 4.19706 6.3335H19.8019C20.1394 6.3335 20.413 6.61953 20.413 6.97232C20.413 7.32511 20.1394 7.61114 19.8019 7.61114Z",
    fill: "#062F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8016 11.0221H4.19678C3.85727 11.0221 3.58203 10.7343 3.58203 10.3794C3.58203 10.0245 3.85727 9.73682 4.19678 9.73682H19.8016C20.1411 9.73682 20.4164 10.0245 20.4164 10.3794C20.4164 10.7343 20.1411 11.0221 19.8016 11.0221Z",
    fill: "#062F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8016 14.4298H4.19678C3.85727 14.4298 3.58203 14.1421 3.58203 13.7871C3.58203 13.4322 3.85727 13.1445 4.19678 13.1445H19.8016C20.1411 13.1445 20.4164 13.4322 20.4164 13.7871C20.4164 14.1421 20.1411 14.4298 19.8016 14.4298Z",
    fill: "#062F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8019 17.8333H4.19706C3.85956 17.8333 3.58594 17.5473 3.58594 17.1945C3.58594 16.8417 3.85956 16.5557 4.19706 16.5557H19.8019C20.1394 16.5557 20.413 16.8417 20.413 17.1945C20.413 17.5473 20.1394 17.8333 19.8019 17.8333Z",
    fill: "#062F53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1594_16093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white",
    transform: "translate(0 2.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswersOther2);
export default __webpack_public_path__ + "static/media/answers_other_2.b1b2f2ba.svg";
export { ForwardRef as ReactComponent };